export default __webpack_public_path__ + "static/media/MulticolorCoral.92e1773f.jpg";